export enum OttopilotLeaderboardWorkspaceCapabilityAccessOperation {
    create = "e74fed68-01d1-4c94-b368-c1b68cb445d4",
    read = "a554561c-2620-4a44-8b9b-33bf2d268241",
    update = "b84c72c3-26b8-46d8-aef0-f3b4eed92ff0",
    delete = "7c832af9-23ef-4454-96c7-5e46342a8d67",
}
